import { ref } from 'vue'

const shouldShowAddToCartOverlay = ref(false)

export const useOpenAddToCartOverlay = () => {
  function openAddToCartOverlay() {
    shouldShowAddToCartOverlay.value = true
  }

  function closeAddToCartOverlay() {
    shouldShowAddToCartOverlay.value = false
  }

  return {
    shouldShowAddToCartOverlay,
    openAddToCartOverlay,
    closeAddToCartOverlay,
  }
}
